// @flow
import * as React from 'react';

export default function findByType(children: React.Element[], component: React.Element) {
  const result = [];

  React.Children.forEach(children, child => {
    if (child.type.displayName === component.name || child.type === component) {
      result.push(child);
    }
  });

  return result[0];
}
